import { SSAI_CONTENT_TYPES } from '../../../app/core/constants'

/**
 * SsaiParameterFactory
 * returns SsaiParameter entity class
 *
 * @class SsaiParameterFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.SsaiParameter} class
 *
 * @ngdoc factory
 * @name mwApp.factory:SsaiParameterFactory
 */
/* @ngInject */

export default function SsaiParameterFactory ($http, $injector, Entity, FileUploadMixin, alertLiteSvc, onOffMixin) {
  /* === SsaiParameter class === */

  /**
   * SsaiParameter model
   *
   * @class SsaiParameter
   * @classdesc SsaiParameter model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @return {models.SsaiParameter} SsaiParameter entity
   */
  function SsaiParameter () {
    const obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  SsaiParameter.prototype = Object.create(Entity.prototype)
  SsaiParameter.prototype.constructor = SsaiParameter

  /* === SsaiParameter instance methods & fields === */

  Object.assign(SsaiParameter.prototype, {

    /**
     * instance fields
     *
     * @memberof models.SsaiParameter#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      description: String,
      contentType: String, // 'VODS'| 'LIVE_CATCHUPS'
      macroId: Number,
      parameters: null,
      placeholder: String,
      enabled: false,
      $parameterType: 'STATIC'
    },

    /**
     * url template
     *
     * @memberof models.SsaiParameter#
     * @type {String}
     */
    _urlTemplate: 'api/mediaurls/{{::contentType}}/parameters/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.SsaiParameter#
     * @type {String}
     */
    _publicUrlTemplate: 'ssais/{{::$contentTypeTab}}/{{::id}}',

    /**
     * Prepare object
     *
     * @memberof models.SsaiParameter#
     * @override
     */
    _prepare: function () {
      this.$contentTypeTab = SsaiParameter.getContentTypeTab(this)
    },

    /**
     * Get underlying object
     *
     * @memberof models.SsaiParameter#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      return Entity.prototype._object.apply(this, arguments)
    }
  }, onOffMixin)

  /* === SsaiParameter static methods & fields === */

  SsaiParameter.getContentTypeTab = function (parameter) {
    return Object.keys(SSAI_CONTENT_TYPES).find(key => SSAI_CONTENT_TYPES[key].request === parameter.contentType)
  }

  SsaiParameter.loadMacros = function (contentType) {
    return $http.get(`api/mediaurls/${contentType}/macros/catalog`)
      .data()
      .then((response) => response.payload)
      .catch(rejection => alertLiteSvc.alertError(rejection))
  }

  SsaiParameter.findMacros = function (parameter, catalog) {
    const macrosByParameter = {}
    for (const parameterType in catalog) {
      macrosByParameter[parameterType] = []
      for (const category of catalog[parameterType]) {
        for (const macros of category.macros) {
          macrosByParameter[parameterType]
            .push({ ...macros, categoryId: category.id, categoryName: category.name })
          if (parameter.macroId === macros.id) {
            parameter.$parameterType = parameterType
            parameter.$category = category
            parameter.$macros = macros
          }
        }
      }
    }

    return macrosByParameter
  }

  // copy all static methods from Entity class
  Object.assign(SsaiParameter, Entity)
  SsaiParameter._name = 'SsaiParameter'
  SsaiParameter._publicName = 'Parameter'
  SsaiParameter.init()

  // permissions
  SsaiParameter.access = {
    view: '',
    create: '',
    edit: '',
    delete: ''
  }

  return SsaiParameter
}
